module.exports = __webpack_public_path__ + "img/Key functions.bf4020d7.png";